import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'semantic-ui-react';
import { toast } from 'react-toastify';

import InputBox from '../../../../../components/InputBox';
import PillButton from '../../../../../components/PillButton';
import Dropdown from '../../../../../components/Dropdown';
import Button from '../../../../../components/Button';
import Spinner from '../../../../../components/Spinner';
import PillSelect from '../../../../../components/PillSelect';
import InputDropdown from '../InputDropdown';

import fetchRecruiterProfile from '../../../../../services/fetchRecruiterProfile';
import getAllCompanies from '../../../../../services/getCompanyManagement';
import getDomainFromCustId from '../../../../../services/getDomainFromCustId';
import getClusters from '../../../../../services/getClusters';


import { natureOfOfferings } from '../../../../../models/natureOfOfferings';
import { getOrganisationTypeArr } from '../../../../../models/organisationType';
import { getNumberOfEmployees } from '../../../../../models/numberOfEmployees';
import { getEstimatedRevenueArr } from '../../../../../models/estimatedRevenue';
import { getFundingStage } from '../../../../../models/fundingStage';
import { getSortedHeadquarterCityList } from '../../../../../models/headquarterCity';
import { getCompanyTags } from '../../../../../models/companyTags';
import { getCompanyBenefits } from '../../../../../models/companyBenefits';
import { getCompanyAwards } from '../../../../../models/companyAwards';
import { getRecruiterTypeArr } from '../../../../../models/recruiterType';

import './CompanyForm.scss';
import syncCompLogosyncCompanyLogo from '../../../../../services/syncCompLogo';

const natureOfOfferingsArr = natureOfOfferings.filter(item => {
    if ([1,2,3,6].indexOf(item.id) > -1) {
        return true;
    }
    return false;
}).map(item => ({ label: item.name, value: item.id }));

const possiblePremiumRanks = [
    {
        id: -1,
        name: 'None'
    },
    {
        id: 11,
        name: 11
    },
    {
        id: 12,
        name: 12
    },
    {
        id: 13,
        name: 13
    },
    {
        id: 14,
        name: 14
    },
    {
        id: 15,
        name: 15
    },
    {
        id: 16,
        name: 16
    },
];

const possiblePremiumRanksiimjobs = [
    {
        id: -1,
        name: 'None'
    },
    {
        id: 11,
        name: 11
    },
    {
        id: 12,
        name: 12
    },
    {
        id: 13,
        name: 13
    },
    {
        id: 14,
        name: 14
    },
    {
        id: 15,
        name: 15
    },
    {
        id: 16,
        name: 16
    },
    {
        id: 17,
        name: 17
    },
    {
        id: 18,
        name: 18
    }
];

const tooltipText = {
    name: 'Example - For Meesho, the legal name would be Fashnear Technologies Pvt. Ltd.',
    displayName: 'Example - Meesho will be the display name',
    domains: 'Add all the relevant domains for the company',
    type: 'Direct Company / Recruitment Firm/Individual Consultant',
    industry: 'Please select the core industry the company works in',
    gcc: 'Captive centers, also known as global in-house centers or global capability centers (GCCs) are client-owned, client-operated delivery centers. Global Captive centers typically function in a non-domestic, talent-rich and low-cost location, providing business-critical outcomes directly to the parent company',
    premiumRanks: '11 to 16, 16 being the most premium',
    premiumRanksIimjobs: '11 to 18, 18 being the most premium',
    groupCompany: 'Is this company a parent company or a subsidiary of another company?'
}


const CompanyForm = (props) => {
    const [subClustersData, setSubClustersData] = useState({});
    // Track which subclusters belong to which clusters
    const [subclusterKey, setSubclusterKey] = useState(0); // Add a counter to force remount
    const [options, setNewOption] = useState([]);
    const [metaKeywordsOptions, setMetaKeywordsOptions] = useState([
    ]);
    const [clusterOptions, setClusterOptions] = useState([]);
    const [subClusterOptions, setSubClusterOptions] = useState([]);
    const [parentCompanyControl, setParentCompanyControl] = useState({
        options: null,
        search: '',
        timerId: null,
        isLoading: true,
        fetch: false,
    });

    const [isGroupCompany, setIsGroupCompany] = useState(false);
    const [checkDomains, setCheckDomains] = useState(false);
    const [domainError, setDomainError] = useState(false);

    const industryRef = useRef(null);
    const [managerDomains, setManagerDomains] = useState([]);

    const [adminId, setAdminId] = useState('');
    const [isAdminLoading, setIsAdminLoading] = useState(false);
    const [adminDetails, setAdminDetails] = useState({
        name: '',
        email: '',
        platform: process.env.REACT_APP_PLATFORM,
        isLoading: false
    });

    const [showAdminForm, setShowAdminForm] = useState(false);

    const [syncAmbitionBoxLogoData, setSyncAmbitionBoxLogoData] = useState({
        processing: false
    });

    const handleSearchAdmin = async () => {
        // return if api call already in progress
        if (isAdminLoading) {
            return;
        }

        setIsAdminLoading(true);

        try {
            const recruiterProfile = await fetchRecruiterProfile(props.adminId, {
                id: adminId
            });

            if (recruiterProfile && recruiterProfile.data) {
                setShowAdminForm(true);
                setAdminId(recruiterProfile.data.id);
                setAdminDetails({
                    email: recruiterProfile.data.email,
                    name: recruiterProfile.data.name,
                    platform: process.env.REACT_APP_PLATFORM
                });

                props.setData({
                    key: 'adminDetails',
                    value: {
                        id: adminId,
                        email: recruiterProfile.data.email,
                        name: recruiterProfile.data.name,
                        platform: process.env.REACT_APP_PLATFORM
                    }
                })
            } else {
                toast.error('Could not find admin profile!');
            }
        } catch (error) {
            toast.error('Could not find admin profile!');
        }

        setIsAdminLoading(false);
    };

    const handleSyncAmbitionBoxLogo = async () => {
        // return if api call already in progress
        if (syncAmbitionBoxLogoData.processing) {
            return;
        }

        setSyncAmbitionBoxLogoData((prevState) => ({
            ...prevState,
            "processing" : true
        }))


        try {
            const res = await syncCompLogosyncCompanyLogo(props.adminId, {centId: props.data.id, imageUrl: props.data.ambitionBoxInfo.companyLogo})
            if(res && res.data && res.data.status == "success"){
                toast.success("sync success")
                setTimeout(() => window.location.reload(), 500);
            }
            else{
                toast.error("something went wrong")
        }
        } catch (error) {
            toast.error('Something Went Wrong');
        }

        setSyncAmbitionBoxLogoData((prevState) => ({
            ...prevState,
            "processing" : false
        }))
    };

    const handleClearAdmin = () => {
        setShowAdminForm(false);
        setAdminId('');

        props.setData({
            key: 'adminDetails',
            value: {}
        });
    }

    useEffect(() => {
        if (checkDomains) {
            if (!props.data.domains || (props.data.domains && props.data.domains.length == 0)) {
                setDomainError([]);
                return;
            }

            getAllCompanies(props.adminId, {
                domainsIn: props.data.domains.join(','),
                // status: 1,
                pageNumber: 1,
                pageContent: 50
            }).then(response => {
                const companies = response.data.data.companies;
                if (companies) {
                    const errorDomains = [];

                    companies.forEach(company => {
                        if (company && company.domains && company.domains.length > 0) {
                            props.data.domains.forEach(domain => {
                                if (props.editMode && company.id == props.data.id) {
                                    return;
                                }
                                if (company.domains.indexOf(domain) > -1 && errorDomains.indexOf(domain) == -1) {
                                    errorDomains.push(domain);
                                }
                            })
                        }
                    })
                    if (errorDomains.length > 0) {
                        setDomainError(errorDomains);
                    } else {
                        setDomainError([]);
                    }

                    props.setData({
                        key: 'errorDomains',
                        value: errorDomains,
                    })
                }
            }).catch(error => {
                setDomainError([]);
            });
        }

        return () => {
            setCheckDomains(false);
        }
    }, [checkDomains]);

    useEffect(() => {
        var arr = [];
        (props.data.domains || []).forEach(element => {
            arr.push({ text: element, value: element });
        });

        setNewOption(arr);
        
        // Call the clusters API and use the response to populate cluster options
        getClusters(props.adminId, { platform: process.env.REACT_APP_PLATFORM })
            .then(response => {
                if (response && response.data && response.data.data && response.data.data.clusters) {
                    // Map the clusters array to the format needed for options (text: name, value: id)
                    setSubClustersData(response.data.data.subclusters);
                    const clusterOptions = response.data.data.clusters.map(cluster => ({
                        text: cluster.name,
                        value: String(cluster.id) // Convert to string to match props.data.cluster values
                    }));
                    setClusterOptions(clusterOptions);

                    // Initialize subclusters for the clusters present in props.data.cluster
                    if (props.data.cluster && props.data.cluster.length > 0) {
                        let allSubclusters = [];
                        
                        // Loop through each cluster ID and collect its subclusters
                        props.data.cluster.forEach(clusterId => {
                            // Convert clusterId to string since the keys in the data are strings
                            const clusterIdStr = String(clusterId);
                            
                            // Check if this cluster ID exists in our data
                            if (response.data.data.subclusters[clusterIdStr]) {
                                // Add all subclusters for this cluster to our collection
                                const subclusters = response.data.data.subclusters[clusterIdStr];
                            
                                // Map the subclusters to the format needed for the dropdown
                                const formattedSubclusters = subclusters.map(subcluster => ({
                                    text: subcluster.nameWithCluster,
                                    value: String(subcluster.id) // Convert to string to match props.data.subCluster values
                                }));
                                
                                // Add these formatted subclusters to our collection
                                allSubclusters = [...allSubclusters, ...formattedSubclusters];
                            }
                        });
                        
                        // Update the subclusters dropdown options
                        setSubClusterOptions(allSubclusters);
                        setSubclusterKey(prevKey => prevKey + 1);
                    }
                }
            })
            .catch(error => {
                console.error('Error fetching clusters:', error);
            });

        if (props.data.groupId) {
            setIsGroupCompany(true);
        }

        // if admin details are already present, then set in the form
        if (props.data.adminDetails && props.data.adminDetails.id) {
            setAdminDetails({
                email: props.data.adminDetails.email,
                name: props.data.adminDetails.name,
                platform: props.data.adminDetails.platform,
            });
            setAdminId(props.data.adminDetails.id);
            setShowAdminForm(true);
        }

        getDomainFromCustId(props.adminId, props.data.infoedgeId).then(r => {

            if (r.data && r.data[0] && r.data[0].domain) 
                setManagerDomains([r.data[0].domain, ...r.data[0].primaryContactEmail, ...r.data[0].secondaryDomain] || []);
                // setManagerDomains(r.data[0].domain || []);

        }).catch(er => {
            console.log("not found --");
        })

    }, []);

    // get company suggestions
    const getCompanySuggestions = () => {
        getAllCompanies(props.adminId, {
            nameLike: parentCompanyControl.search,
            groupCompaniesOnly: true,
            pageNumber: 1,
            pageContent: 50
        }).then(response => {
            if (response && response.data && response.data.data && response.data.data.companies) {
                const companies = response.data.data.companies;

                if (!companies || (companies && companies.length == 0)) {
                    setParentCompanyControl(prevObj => {
                        return {
                            ...prevObj,
                            options: [],
                            isLoading: false,
                            timerId: null,
                            fetch: false
                        }
                    })
                    return;
                }
                const opts = companies.map(item => {
                    return {
                        value: item.id,
                        label: item.name,
                    }
                });

                setParentCompanyControl(prevObj => {
                    return {
                        ...prevObj,
                        options: opts,
                        isLoading: false,
                        timerId: null,
                        fetch: false
                    }
                })
            }
        }).catch(error => {
            setParentCompanyData(prevObj => {
                return {
                    ...prevObj,
                    options: null,
                    timerId: null,
                    fetch: false,
                };
            });
        })
    };

    // fire when timeout finishes
    useEffect(() => {
        if (parentCompanyControl.fetch) {
            getCompanySuggestions();
        }
    }, [parentCompanyControl.fetch]);

    // will fire everytime when search value changes, if timer id is not set, then it will create a timeout
    // if timer id already exists, return
    // if search is cleared, reset control
    useEffect(() => {
        if (!parentCompanyControl.search) {
            setParentCompanyControl({
                options: null,
                search: '',
                timerId: null,
            });

            return;
        }

        if (parentCompanyControl.timerId) {
            console.log('timer already active');

            return;
        }

        const timerId = setTimeout(() => {
            setParentCompanyData('fetch', true);
        }, 1000);

        setParentCompanyControl(prevObj => {
            return {
                ...prevObj,
                timerId: timerId,
                options: [],
                isLoading: true,
            }
        });
    }, [parentCompanyControl.search]);

    // helper function to set parent company data
    const setParentCompanyData = (key, value) => {
        setParentCompanyControl(prevObj => {
            const newObj = { ...prevObj };

            newObj[key] = value;
            return newObj;
        });
    };

    return (
        
        <div>
            <div className="inputGroup">
                <label className="managementLabels">Company Name (Legal Entity Name)*: </label>

                <div className="managementInputFields">
                    {' '}
                    <InputBox
                        placeholder="Enter company name"
                        type="text"
                        value={props.data.name}
                        name="name"
                        onChange={(e) => {
                            props.setData({
                                key: 'name',
                                value: e.target.value,
                            });
                        }}
                    />

                    <div className='desc-text'>{tooltipText['name']}</div>
                </div>
            </div>
            <div className="inputGroup">
                <label className="managementLabels">
                    Display Name/Brand Name* : 
                </label>

                <div className="managementInputFields">
                    {' '}
                    <InputBox
                        type="text"
                        placeholder="Enter display/brand name"
                        value={props.data.displayName}
                        name="displayName"
                        onChange={(e) => {
                            props.setData({
                                key: 'displayName',
                                value: e.target.value,
                            });
                        }}
                    />

                    <div className='desc-text'>{tooltipText['displayName']}</div>
                </div>
            </div>

            <div className="inputGroup">
                <label className="managementLabels">
                    Domains* :
                </label>

                <div className="managementInputFields">
                    <PillButton
                        name="domains"
                        onChange={(e, data) => {
                            props.setData({
                                key: 'domains',
                                value: data.value,
                            });
                            // setCheckDomains(true);
                        }}
                        placeholder="Enter domain(s)"
                        allowAdditions={true}
                        data={options}
                        defaultValue={props.data.domains}
                        onAddOtherLocation={(e, { value }) => {
                            // setCheckDomains(true);

                            var newop = options;
                            newop.push({ text: value, value })
                            setNewOption(newop)
                        }}
                        // error={domainError && domainError.length > 0 ? true : false}
                    />

                    <div className='desc-text'>{tooltipText['domains']}</div>
                    {/* {domainError && domainError.length > 0 ? (
                        <div className='error-text'>The domain {domainError[0]} already exists, please map with a group company if required</div>
                    ) : null} */}
                </div>
            </div>

            {(props.editMode && props.data.status == 1) || !props.editMode ? (
                <div className="inputGroup">
                    <label className="managementLabels">Group Company: </label>
                    <div className="managementInputFields">
                        <Checkbox
                            name='parentCompany'
                            checked={isGroupCompany}
                            onChange={(event, data) => {
                                setIsGroupCompany(data.checked);
                                if (!data.checked) {
                                    props.setData({
                                        key: 'groupId',
                                        value: null,
                                    });
                                } else if (props.data.groupId) {
                                    props.setData({
                                        key: 'groupId',
                                        value: props.data.groupId,
                                    })
                                }
                            }}
                        />

                        <div className='desc-text'>{tooltipText['groupCompany']}</div>
                    </div>
                </div>
            ) : null}

            {isGroupCompany ? (
                <>
                    <div className='inputGroup'>
                        <label className='managementLabels'>
                            This is a parent company:
                        </label>
                        <div className="managementInputFields">
                            <Checkbox
                                defaultChecked={props.data.isParentCompany || (props.data.id && props.data.groupId && props.data.groupId == props.data.id) ? true : false}
                                onChange={(event, data) => {
                                    props.setData({
                                        key: 'isParentCompany',
                                        value: data.checked ? 1 : null,
                                    });
                                }}
                            />
                        </div>
                    </div>
                
                    {!props.data.isParentCompany ? (
                        <div className="inputGroup">
                            <label className="managementLabels">
                                Parent Company* :
                            </label>

                            <div className="managementInputFields">
                                {' '}
                                <InputDropdown
                                    name="parentCompany"
                                    options={parentCompanyControl.options}
                                    isLoading={parentCompanyControl.isLoading}
                                    onSearchChange={(searchValue) => {
                                        setParentCompanyData('search', searchValue);
                                    }}
                                    onItemSelect={(companyItem) => {
                                        if (!companyItem.value) {
                                            setParentCompanyData('options', null);
                                        }
                                        props.setData({
                                            key: 'parentCompany',
                                            value: companyItem,
                                        })
                                    }}
                                    selectedLabel={props.data.groupName}
                                    selectedValue={props.data.groupId}
                                />
                            </div>
                        </div>
                    ) : null}
                </>
            ) : null}

            <div className="inputGroup">
                <label className="managementLabels">Company Type* :</label>

                <div className="managementInputFields">
                    {' '}
                    <select onChange={(e) => {
                        props.setData({
                            key: 'type',
                            value: e.target.value,
                        });
                    }} >
                        <option name="recType" value="">
                            Select Employer Type
                        </option>
                        {
                            getRecruiterTypeArr().map((op) => {
                                return props.data.type == op.value ? <option name="recType" value={op.value} selected>
                                    {op.text}
                                </option> : <option name="recType" value={op.value}>
                                    {op.text}
                                </option>
                            })
                        }
                    </select>
                </div>
            </div>

            <div className="inputGroup">
                <label className="managementLabels">Industry* :</label>

                <div className="managementInputFields">
                    {' '}
                    <select name='industry' ref={industryRef} onChange={(e) => {
                        props.setData({
                            key: 'industry',
                            value: parseInt(e.target.value),
                        });
                    }} >
                        <option name="recType" value="">Select Industry</option>
                        {props.industry.map((ind) => {
                            return props.data.industry == ind.id ? <option name="recType" value={ind.id} selected>
                                {ind.name}
                            </option> : <option name="recType" value={ind.id}>
                                {ind.name}
                            </option>
                        })}
                    </select>

                    <div className='desc-text'>{tooltipText['industry']}</div>
                </div>
            </div>

            {/* if classification is IT then show */}
            {props.data.classification == 1 ? (
                <div className="inputGroup">
                    <label className="managementLabels">Nature of Business* :</label>

                    <div className="managementInputFields">
                        {' '}
                        <select name="type" onChange={(e) => {
                            props.setData({
                                key: 'natureOfOffering',
                                value: e.target.value,
                            });
                        }} >
                            <option name="natureOfOffering" value="">
                                Select Nature of Business
                            </option>
                            {
                                natureOfOfferingsArr.map((op) => {
                                    return props.data.natureOfOffering == op.value ? <option name="natureOfOffering" value={op.value} selected>
                                        {op.label}
                                    </option> : <option name="natureOfOffering" value={op.value}>
                                        {op.label}
                                    </option>
                                })
                            }
                        </select>
                    </div>
                </div>
            ) : null}

            <div className="inputGroup">
                <label className="managementLabels">Organisation Type* :</label>

                <div className="managementInputFields">
                    {' '}
                    <select name="companyType" onChange={(e) => {
                        props.setData({
                            key: 'companyType',
                            value: e.target.value,
                        });
                    }} >
                        <option name="companyType" value="">
                            Select Organisation Type
                        </option>
                        {
                            getOrganisationTypeArr().slice(1).map((op) => {

                                return props.data.companyType == op.value ? <option name="companyType" value={op.value} selected>
                                    {op.label}
                                </option> : <option name="companyType" value={op.value}>
                                    {op.label}
                                </option>
                            })
                        }
                    </select>
                </div>
            </div>

            {props.data.companyType == 1 ? (
                <>
                    <div className="inputGroup">
                        <label className="managementLabels">Funding Stage :</label>

                        <div className="managementInputFields">
                            {' '}
                            <select onChange={(e) => {
                                props.setData({
                                    key: 'fundingStage',
                                    value: e.target.value,
                                });
                            }} >
                                {
                                    getFundingStage().map((op) => {
                                        return props.data.fundingStage == op.id ? <option name="fundingStage" value={op.id} selected>
                                            {op.name}
                                        </option> : <option name="fundingStage" value={op.id}>
                                            {op.name}
                                        </option>
                                    })
                                }
                            </select>
                        </div>
                    </div>
                    <div className="inputGroup">
                        <label className="managementLabels">Valuation :</label>

                        <div className="managementInputFields">
                            {' '}
                            <InputBox
                                type="text"
                                placeholder="Enter valuation"
                                value={props.data.valuation}
                                name="valuation"
                                onChange={(e) => {
                                    props.setData({
                                        key: 'valuation',
                                        value: e.target.value,
                                    });
                                }}
                            />
                        </div>
                    </div>
                </>
            ) : (
                <div className="inputGroup">
                    <label className="managementLabels">Estimated Revenue:</label>

                    <div className="managementInputFields">
                        {' '}
                        <select onChange={(e) => {
                            props.setData({
                                key: 'estimatedRevenue',
                                value: e.target.value,
                            });
                        }} >
                            <option name="estimatedRevenue" value="">
                                Select Estimated Revenue
                            </option>
                            {
                                getEstimatedRevenueArr().map((op) => {
                                    return props.data.estimatedRevenue == op.value ? <option name="estimatedRevenue" value={op.value} selected>
                                        {op.label}
                                    </option> : <option name="estimatedRevenue" value={op.value}>
                                        {op.label}
                                    </option>
                                })
                            }
                        </select>
                    </div>
                </div>
            )}

            <div className="inputGroup">
                <label className="managementLabels">Unicorn Status: </label>
                <div className="managementInputFields">
                    <Checkbox
                        defaultChecked={props.data.unicornStatus == 1 ? true : false}
                        onChange={(event, data) => {
                            props.setData({
                                key: 'unicornStatus',
                                value: data.checked ? 1 : null,
                            });
                        }}
                    />
                </div>
            </div>

            <div className="inputGroup">
                <label className="managementLabels">Captive/GCC: </label>
                <div className="managementInputFields">
                    <div className='checkbox-group'>
                        <Checkbox
                            label="Captive"
                            defaultChecked={props.data.captive == 1 ? true : false}
                            checked={props.data.captive == 1 ? true : false}
                            onChange={(event, data) => {
                                props.setData({
                                    key: 'captive',
                                    value: data.checked ? 1 : null,
                                });
                            }}
                        />

                        <Checkbox
                            label="GCC"
                            defaultChecked={props.data.gcc == 1 ? true : false}
                            checked={props.data.gcc == 1 ? true : false}
                            onChange={(event, data) => {
                                props.setData({
                                    key: 'gcc',
                                    value: data.checked ? 1 : null,
                                });
                            }}
                        />
                    </div>
                    <div className='desc-text'>{tooltipText['gcc']}</div>
                </div>
            </div>

            <div className="inputGroup">
                <label className="managementLabels">Premium Rank - Hirist :</label>
                <div className="managementInputFields">
                    <Dropdown
                        data={possiblePremiumRanks}
                        defaultValue={props.data.tempPremiumRanks ? props.data.tempPremiumRanks.hirist : null}
                        name="premiumRanksHiristDropdown"
                        dropdownChange={(event) => {
                            const value = event.target.value == -1 ? null : parseInt(event.target.value);
                            props.setData({
                                key: 'premiumRanks.hirist',
                                value: value,
                            });
                        }}
                    />
                    <div className='desc-text'>{tooltipText['premiumRanks']}</div>
                </div>
            </div>

            <div className="inputGroup">
                <label className="managementLabels">Premium Rank - Iimjobs: </label>
                <div className="managementInputFields">
                    <Dropdown
                        data={possiblePremiumRanksiimjobs}
                        defaultValue={props.data.tempPremiumRanks ? props.data.tempPremiumRanks.iimjobs : null}
                        name="premiumRanksIimjobsDropdown"
                        dropdownChange={(event) => {
                            const value = event.target.value == -1 ? null : parseInt(event.target.value);
                            props.setData({
                                key: 'premiumRanks.iimjobs',
                                value: value,
                            });
                        }}
                    />
                    <div className='desc-text'>{tooltipText['premiumRanksIimjobs']}</div>
                </div>
            </div>

            <div className="inputGroup">
                <label className="managementLabels">Premium Rank - Updazz: </label>
                <div className="managementInputFields">
                    <Dropdown
                        data={possiblePremiumRanks}
                        defaultValue={props.data.tempPremiumRanks ? props.data.tempPremiumRanks.updazz : null}
                        name="premiumRanksUpdazzDropdown"
                        dropdownChange={(event) => {
                            const value = event.target.value == -1 ? null : parseInt(event.target.value);
                            props.setData({
                                key: 'premiumRanks.updazz',
                                value: value,
                            });
                        }}
                    />
                    <div className='desc-text'>{tooltipText['premiumRanks']}</div>
                </div>
            </div>

            <div className="inputGroup">
                <label className="managementLabels">Company Size :</label>

                <div className="managementInputFields">
                    {' '}
                    <select onChange={(e) => {
                        props.setData({
                            key: 'noOfEmployees',
                            value: e.target.value,
                        });
                    }} >
                        {
                            getNumberOfEmployees().map((op) => {
                                return props.data.noOfEmployees == op.value ? <option name="noOfEmployees" value={op.value} selected>
                                    {op.label}
                                </option> : <option name="noOfEmployees" value={op.value}>
                                    {op.label}
                                </option>
                            })
                        }
                    </select>
                </div>
            </div>

            <div className="inputGroup">
                <label className="managementLabels">Headquater Location :</label>

                <div className="managementInputFields">
                    {' '}
                    <select onChange={(e) => {
                        props.setData({
                            key: 'headquaterCity',
                            value: e.target.value,
                        });
                    }} >
                        <option name="headquaterCity" value="">
                            Select Headquater Location
                        </option>
                        {
                            getSortedHeadquarterCityList().slice(1).map((op) => {
                                return props.data.headquaterCity == op.id ? <option name="headquaterCity" value={op.id} selected>
                                    {op.name}
                                </option> : <option name="headquaterCity" value={op.id}>
                                    {op.name}
                                </option>
                            })
                        }
                    </select>
                </div>
            </div>
        
            <div className="inputGroup">
                <label className="managementLabels">
                    Other office locations :
                </label>

                <div className="managementInputFields">
                    <PillButton
                        onChange={(e, data) => {
                            props.setData({
                                key: 'otherOfficeLocations',
                                value: data.value,
                            });
                        }}
                        placeholder="Select other office location"
                        allowAdditions={false}
                        data={getSortedHeadquarterCityList().slice(1).map(item => ({ text: item.name, value: parseInt(item.id) }))}
                        defaultValue={props.data.otherOfficeLocations}
                    />
                </div>
            </div>

            <div className="inputGroup">
                <label className="managementLabels">
                    Important Tags :
                </label>

                <div className="managementInputFields">
                    <PillSelect 
                        options={getCompanyTags()}
                        selectedOptions={props.data.tags}
                        onSelectOption={(optsId) => {
                            let newOpts = props.data.tags;

                            if (!newOpts) {
                                newOpts = [];
                            }

                            if (newOpts.indexOf(optsId) == -1) {
                                newOpts.push(optsId);
                            } else {
                                newOpts = newOpts.filter(item => item != optsId);
                            }

                            props.setData({
                                key: 'tags',
                                value: newOpts,
                            });
                        }}
                    />
                    {/* <PillButton
                        placeholder="Select tags"
                        onChange={(e, data) => {
                            props.setData({
                                key: 'tags',
                                value: data.value,
                            });
                        }}
                        allowAdditions={false}
                        data={getCompanyTags().map(item => ({ text: item.value, value: item.id }))}
                        defaultValue={props.data.tags}
                    /> */}
                </div>
            </div>

            <div className="inputGroup">
                <label className="managementLabels">
                    Benefits :
                </label>

                <div className="managementInputFields">
                    <PillSelect 
                        options={getCompanyBenefits()}
                        selectedOptions={props.data.benefits}
                        onSelectOption={(optsId) => {
                            let newOpts = props.data.benefits;

                            if (!newOpts) {
                                newOpts = [];
                            }

                            if (newOpts.indexOf(optsId) == -1) {
                                newOpts.push(optsId);
                            } else {
                                newOpts = newOpts.filter(item => item != optsId);
                            }

                            props.setData({
                                key: 'benefits',
                                value: newOpts,
                            });
                        }}
                    />
                    {/* <PillButton
                        placeholder="Select benefits"
                        onChange={(e, data) => {
                            props.setData({
                                key: 'benefits',
                                value: data.value,
                            });
                        }}
                        allowAdditions={false}
                        data={getCompanyBenefits().map(item => ({ text: item.value, value: item.id }))}
                        defaultValue={props.data.benefits}
                    /> */}
                </div>
            </div>

            <div className="inputGroup">
                <label className="managementLabels">
                    Awards :
                </label>

                <div className="managementInputFields">
                    <PillSelect 
                        options={getCompanyAwards()}
                        selectedOptions={props.data.awards}
                        onSelectOption={(optsId) => {
                            let newOpts = props.data.awards;

                            if (!newOpts) {
                                newOpts = [];
                            }

                            if (newOpts.indexOf(optsId) == -1) {
                                newOpts.push(optsId);
                            } else {
                                newOpts = newOpts.filter(item => item != optsId);
                            }

                            props.setData({
                                key: 'awards',
                                value: newOpts,
                            });
                        }}
                    />
                    {/* <PillButton
                        placeholder="Select awards"
                        onChange={(e, data) => {
                            props.setData({
                                key: 'awards',
                                value: data.value,
                            });
                        }}
                        allowAdditions={false}
                        data={getCompanyAwards().map(item => ({ text: item.value, value: item.id }))}
                        defaultValue={props.data.awards}
                    /> */}
                </div>
            </div>

            <div className="inputGroup">
                <label className="managementLabels">Comments :</label>

                <div className="managementInputFields">
                    {' '}
                    <InputBox
                        type="text"
                        placeholder="Add comments"
                        value={props.data.comment}
                        name="comment"
                        onChange={(e) => {
                            props.setData({
                                key: 'comment',
                                value: e.target.value,
                            });
                        }}
                    />
                </div>
            </div>

            <div className="inputGroup">
                <label className="managementLabels">
                    Description :
                </label>

                <div className="managementInputFields">
                    <textarea
                        placeholder='Add description'
                        rows={5}
                        className='description'
                        value={props.data.description}
                        name='description'
                        onChange={(event) => {
                            props.setData({
                                key: 'description',
                                value: event.target.value,
                            })
                        }}
                    />
                </div>
            </div>

            <div className="inputGroup">
                <label className="managementLabels">
                    Founding Year:
                </label>

                <div className="managementInputFields">
                    <InputBox
                        placeholder="Enter founding year"
                        type="number"
                        value={props.data.companyFounded}
                        name="companyFounded"
                        onKeyPress={(e) => {
                            if (['e', 'E', '+', '-'].includes(e.key)) {
                                e.preventDefault();
                            }
                        }}
                        onChange={(e) => {
                            if (e.target.value && Number.isNaN(parseInt(e.target.value))) {
                                return;
                            }
                            if (e.target.value && e.target.value.length > 4) {
                                return;
                            }
                            props.setData({
                                key: 'companyFounded',
                                value: e.target.value,
                            });
                        }}
                    />
                    {/* <select onChange={(e) => {
                        props.setData({
                            key: 'companyFounded',
                            value: e.target.value,
                        });
                    }} >
                        {
                            getCompanyFounded().map((op) => {
                                return props.data.companyFounded == op.id ? <option name="companyFounded" value={op.id} selected>
                                    {op.name}
                                </option> : <option name="companyFounded" value={op.id}>
                                    {op.name}
                                </option>
                            })
                        }
                    </select> */}
                </div>
            </div>

            <div className="inputGroup">
                <label className="managementLabels">Cluster: </label>
                <div className="managementInputFields">
                    <PillButton
                        name="cluster"
                        onChange={(e, data) => {
                            props.setData({
                                key: 'cluster',
                                value: data.value,
                            });
                            let clusterIds = data.value;
                            // Initialize an array to hold all subclusters for the provided cluster IDs
                            let allSubclusters = [];
                            
                            // Loop through each cluster ID and collect its subclusters
                            clusterIds.forEach(clusterId => {
                                // Convert clusterId to string since the keys in the data are strings
                                const clusterIdStr = String(clusterId);
                                
                                // Check if this cluster ID exists in our data
                                if (subClustersData[clusterIdStr]) {
                                    // Add all subclusters for this cluster to our collection
                                    const subclusters = subClustersData[clusterIdStr];
                                
                                // Map the subclusters to the format needed for the dropdown (text/value pairs)
                                const formattedSubclusters = subclusters.map(subcluster => ({
                                    text: subcluster.nameWithCluster,
                                    value: String(subcluster.id)
                                }));
                                
                                // Add these formatted subclusters to our collection
                                allSubclusters = [...allSubclusters, ...formattedSubclusters];
                                }
                            });
                            // Update the subclusters dropdown options
                            setSubClusterOptions(allSubclusters);
                            
                            // Filter out subclusters that are no longer available
                            if (props.data.subCluster && props.data.subCluster.length > 0) {
                                // Get all valid subcluster IDs from the current options
                                const validSubclusterIds = allSubclusters.map(item => item.value);
                                
                                // Filter out subclusters that aren't in the current options
                                const filteredSubclusters = props.data.subCluster.filter(
                                    id => validSubclusterIds.includes(id)
                                );
                                
                                // Update the subcluster selection if it changed
                                if (filteredSubclusters.length !== props.data.subCluster.length) {
                                    props.setData({
                                        key: 'subCluster',
                                        value: filteredSubclusters.length > 0 ? filteredSubclusters : null
                                    });
                                }
                            }
                            
                            // Increment the subcluster key to force the dropdown to reset
                            setSubclusterKey(prevKey => prevKey + 1);
                            // Increment the cluster key to force the dropdown to reset
                        }}
                        placeholder="Select cluster"
                        allowAdditions={false}
                        data={clusterOptions}
                        defaultValue={props.data.cluster}
                        onAddOtherLocation={(e, { value }) => {
                            var newKeywords = [...clusterOptions];
                            newKeywords.push({ text: value, value });
                            setClusterOptions(newKeywords);
                        }}
                        disabled={!props.companyClusterEditAccess}
                    />
                </div>
            </div>

            <div className="inputGroup">
                <label className="managementLabels">Sub Cluster: </label>
                <div className="managementInputFields">
                    <PillButton
                        key={`subcluster-${subclusterKey}`}
                        name="subCluster"
                        onChange={(e, data) => {
                            props.setData({
                                key: 'subCluster',
                                value: data.value,
                            });
                        }}
                        placeholder="Select sub cluster"
                        allowAdditions={false}
                        data={subClusterOptions}
                        defaultValue={props.data.subCluster}
                        onAddOtherLocation={(e, { value }) => {
                            var newKeywords = [...subClusterOptions];
                            newKeywords.push({ text: value, value });
                            setSubClusterOptions(newKeywords);
                        }}
                        disabled={!props.companyClusterEditAccess}
                    />
                </div>
            </div>

            {(props.localFieldsEditAccess && (props.editMode && (props.data.status == 1))) &&
                <div className="inputGroup"> 
                    <label className="managementLabels">
                        Company Logo:
                    </label>

                    <div className="managementInputFields logoInputFields">
                        {(props.data.companyLogoFilePath || props.data.companyLogoFile) && <img src={props.data.companyLogoFile ? URL.createObjectURL(props.data.companyLogoFile) : props.data.companyLogoFilePath} style={{width: "100px"}}/>}
                        <InputBox 
                            type="file"
                            name="picture_upload" 
                            accept="image/jpg, image/jpeg, image/png, image/gif, image/bmp, image/svg+xml, image/webp" 
                            onChange={ (e) =>  
                            {
                                props.setData({
                                    key: 'companyLogoFile',
                                    value: e.target.files[0],
                                })
                            }
                        } 
                        />
                        {
                        props.data.companyLogoFilePath && 
                        <div className="managementInputFields">
                            {' '}
                            <InputBox
                                type="text"
                                placeholder="s3 url"
                                value={props.data.companyLogoFilePath}
                                name="s3Url"
                                onChange={(e) => {
                                    props.setData({
                                        key: 'companyLogoFilePath',
                                        value: e.target.value,
                                    });
                                }}
                            />
                        </div>
                    }
                    </div>
                </div>
            }

            {
                (props.localFieldsEditAccess && props.data.ambitionBoxInfo && (props.editMode && (props.data.status == 1))) &&
                <div>
                    <h2>
                        Ambition box fields (Read Only):
                    </h2>

                    <br></br>  
                    <br></br>  
                    
                    <div className="inputGroup">
                        <label className="managementLabels">Ambition Box Company Id: </label>

                        <div className="managementInputFields">
                            {' '}
                            <InputBox
                                placeholder="ambitionBoxCompanyId"
                                type="text"
                                value={props.data.ambitionBoxInfo.ambitionBoxCompanyId}
                                name="name"
                            />

                        </div>
                    </div>
                    <div className="inputGroup">
                        <label className="managementLabels">Company Name: </label>

                        <div className="managementInputFields">
                            {' '}
                            <InputBox
                                placeholder="companyName"
                                type="text"
                                value={props.data.ambitionBoxInfo.companyName}
                                name="name"
                            />

                        </div>
                    </div>
                    <div className="inputGroup">
                        <label className="managementLabels">Reviews count: </label>

                        <div className="managementInputFields">
                            {' '}
                            <InputBox
                                placeholder="reviewsCount"
                                type="text"
                                value={props.data.ambitionBoxInfo.reviewsCount}
                                name="name"
                            />

                        </div>
                    </div>
                    <div className="inputGroup">
                        <label className="managementLabels">company Logo: </label>

                        <div className="managementInputFields ambitionBoxlogoField">
                            {' '}
                            <img src={props.data.ambitionBoxInfo.companyLogo} style={{width: "100px"}}/>
                            {/* <InputBox
                                placeholder="companyLogo"
                                type="text"
                                value={props.data.ambitionBoxInfo.companyLogo}
                                name="name"
                            /> */}
                            { !props.data.companyLogoFilePath && 
                                <div>
                                    <Button
                                        skin='dark'
                                        text="Set as centralized company Logo"
                                        disabled={syncAmbitionBoxLogoData.processing}
                                        loading={syncAmbitionBoxLogoData.processing}
                                        clickButton={handleSyncAmbitionBoxLogo}
                                    />
                                </div>
                            }
                        </div>
                    </div>
                    <div className="inputGroup">
                        <label className="managementLabels">Other tags: </label>

                        <div className="managementInputFields">
                            {' '}
                            <InputBox
                                placeholder="otherTags"
                                type="text"
                                value={props.data.ambitionBoxInfo.otherTags && props.data.ambitionBoxInfo.otherTags.join(", ")}
                                name="name"
                            />

                        </div>
                    </div>
                    <div className="inputGroup">
                        <label className="managementLabels">title: </label>

                        <div className="managementInputFields">
                            {' '}
                            <InputBox
                                placeholder="title"
                                type="text"
                                value={props.data.ambitionBoxInfo.title}
                                name="name"
                            />

                        </div>
                    </div>
                    <div className="inputGroup">
                        <label className="managementLabels">url: </label>

                        <div className="managementInputFields">
                            {' '}
                            <InputBox
                                placeholder="url"
                                type="text"
                                value={props.data.ambitionBoxInfo.url}
                                name="name"
                            />

                        </div>
                    </div>
                    <div className="inputGroup">
                        <label className="managementLabels">Ambition Box Company Id: </label>

                        <div className="managementInputFields">
                            {' '}
                            <InputBox
                                placeholder="aggregateRating"
                                type="text"
                                value={props.data.ambitionBoxInfo.aggregateRating}
                                name="name"
                            />

                        </div>
                    </div>
                    <div className="inputGroup">
                        <label className="managementLabels">aggregateRatingOneDecimal: </label>

                        <div className="managementInputFields">
                            {' '}
                            <InputBox
                                placeholder="aggregateRatingOneDecimal"
                                type="text"
                                value={props.data.ambitionBoxInfo.aggregateRatingOneDecimal}
                                name="name"
                            />

                        </div>
                    </div>
                </div>
            }

            {
                <div>
                    <h2>
                        Seo Fields
                    </h2>

                    <br></br>  
                    <br></br>  
                    
                    <div className="inputGroup">
                        <label className="managementLabels">Slug: </label>

                        <div className="managementInputFields">
                            {' '}
                            <InputBox
                                placeholder="Enter slug"
                                type="text"
                                value={props.data.seo ? props.data.seo.slug : null}
                                name="name"
                                onChange={(e) => {
                                    props.setData({
                                        key: 'seo.slug',
                                        value: e.target.value,
                                    });
                                }}
                            />

                        </div>
                    </div>
                    <div className="inputGroup">
                        <label className="managementLabels">Hirist Page Title: </label>

                        <div className="managementInputFields">
                            {' '}
                            <InputBox
                                placeholder="Enter hirist page title"
                                type="text"
                                value={props.data.seo ? props.data.seo.hiristPageTitle : null}
                                name="name"
                                onChange={(e) => {
                                    props.setData({
                                        key: 'seo.hiristPageTitle',
                                        value: e.target.value,
                                    });
                                }}
                            />

                        </div>
                    </div>
                    <div className="inputGroup">
                        <label className="managementLabels">IIMJobs Page Title: </label>

                        <div className="managementInputFields">
                            {' '}
                            <InputBox
                                placeholder="Enter iimjobs page title"
                                type="text"
                                value={props.data.seo? props.data.seo.iimjobsPageTitle: null}
                                name="name"
                                onChange={(e) => {
                                    props.setData({
                                        key: 'seo.iimjobsPageTitle',
                                        value: e.target.value,
                                    });
                                }}
                            />

                        </div>
                    </div>
                    <div className="inputGroup">
                        <label className="managementLabels">Meta Keywords: </label>

                        <div className="managementInputFields">
                            <PillButton
                                name="metaKeywords"
                                onChange={(e, data) => {
                                    props.setData({
                                        key: 'seo.metaKeywords',
                                        value: data.value,
                                    });
                                }}
                                placeholder="Enter meta keywords"
                                allowAdditions={true}
                                data={metaKeywordsOptions}
                                defaultValue={props.data.seo ? props.data.seo.metaKeywords: null}
                                onAddOtherLocation={(e, { value }) => {
                                    var newKeywords = [...metaKeywordsOptions];
                                    newKeywords.push({ text: value, value });
                                    setMetaKeywordsOptions(newKeywords);
                                }}
                            />
                        </div>
                    </div>
                    <div className="inputGroup">
                        <label className="managementLabels">Hirist Meta Description: </label>

                        <div className="managementInputFields">
                            {' '}
                            <InputBox
                                placeholder="Enter hirist meta description"
                                type="text"
                                value={props.data.seo ? props.data.seo.hiristMetaDescription: null}
                                name="name"
                                onChange={(e) => {
                                    props.setData({
                                        key: 'seo.hiristMetaDescription',
                                        value: e.target.value,
                                    });
                                }}
                            />

                        </div>
                    </div>
                    <div className="inputGroup">
                        <label className="managementLabels">IIMJobs Meta Description: </label>

                        <div className="managementInputFields">
                            {' '}
                            <InputBox
                                placeholder="Enter iimjobs meta description"
                                type="text"
                                value={props.data.seo ? props.data.seo.iimjobsMetaDescription: null}
                                name="name"
                                onChange={(e) => {
                                    props.setData({
                                        key: 'seo.iimjobsMetaDescription',
                                        value: e.target.value,
                                    });
                                }}
                            />

                        </div>
                    </div>
                    <div className="inputGroup">
                        <label className="managementLabels">Source: </label>

                        <div className="managementInputFields">
                            {' '}
                            <InputBox
                                placeholder="Enter source"
                                type="text"
                                value={props.data.seo ? props.data.seo.source: null}
                                name="name"
                                onChange={(e) => {
                                    props.setData({
                                        key: 'seo.source',
                                        value: e.target.value,
                                    });
                                }}
                            />

                        </div>
                    </div>
                    <div className="inputGroup">
                        <label className="managementLabels">Ref Code: </label>

                        <div className="managementInputFields">
                            {' '}
                            <InputBox
                                placeholder="Enter ref code"
                                type="text"
                                value={props.data.seo ? props.data.seo.refCode: null}
                                name="name"
                                onChange={(e) => {
                                    props.setData({
                                        key: 'seo.refCode',
                                        value: e.target.value,
                                    });
                                }}
                            />

                        </div>
                    </div>
                </div>
            }

            {/* keep in last */}
            <div className='restricted-fields'>
                <div className='inputGroup'>
                    <label className="managementLabels">InfoEdge Id :</label>

                    <div className="managementInputFields">
                        {' '}
                        <InputBox
                            disabled={props.fieldsEditAccess ? null : true}
                            placeholder="Enter infoedge id"
                            type="text"
                            value={props.data.infoedgeId}
                            name="infoedgeId"
                            onChange={(e) => {
                                props.setData({
                                    key: 'infoedgeId',
                                    value: e.target.value,
                                });
                            }}
                        />
                        <div className='manager-dashboard-domains'> {managerDomains ? managerDomains.join(",") : null} </div>
                    </div>
                </div>

                <div className="inputGroup">
                    <label className="managementLabels">Hirist Id :</label>

                    <div className="managementInputFields">
                        {' '}
                        <InputBox
                            disabled={props.fieldsEditAccess ? null : true}
                            placeholder="Enter hirist id"
                            type="text"
                            value={props.data.hiristId}
                            name="hiristId"
                            onChange={(e) => {
                                props.setData({
                                    key: 'hiristId',
                                    value: e.target.value,
                                });
                            }}
                        />
                    </div>
                </div>

                <div className="inputGroup">
                    <label className="managementLabels">iimjobs Id :</label>

                    <div className="managementInputFields">
                        {' '}
                        <InputBox
                            disabled={props.fieldsEditAccess ? null : true}
                            placeholder="Enter iimjobs id"
                            type="text"
                            value={props.data.iimjobsId}
                            name="iimjobsId"
                            onChange={(e) => {
                                props.setData({
                                    key: 'iimjobsId',
                                    value: e.target.value,
                                });
                            }}
                        />
                    </div>
                </div>

                <div className="inputGroup">
                    <label className="managementLabels">Updazz Id :</label>

                    <div className="managementInputFields">
                        {' '}
                        <InputBox
                            disabled={props.fieldsEditAccess ? null : true}
                            placeholder="Enter updazz id"
                            type="text"
                            value={props.data.updazzId}
                            name="updazzId"
                            onChange={(e) => {
                                props.setData({
                                    key: 'updazzId',
                                    value: e.target.value,
                                });
                            }}
                        />
                    </div>
                </div>

                <div className="inputGroup">
                    <label className="managementLabels">First Party Email :</label>

                    <div className="managementInputFields">
                        {' '}
                        <InputBox
                            disabled={props.fieldsEditAccess ? null : true}
                            placeholder="Enter first party email"
                            type="text"
                            value={props.data.firstPartyEmail}
                            name="firstPartyEmail"
                            onChange={(e) => {
                                props.setData({
                                    key: 'firstPartyEmail',
                                    value: e.target.value.trim(),
                                });
                            }}
                        />
                    </div>
                </div>

                <div className="inputGroup">
                    <label className="managementLabels">Platforms to hide from: </label>
                    <div className="managementInputFields">
                        <div className="toHideCheckboxContainer">
                            <Checkbox
                                disabled={props.fieldsEditAccess ? false : true}
                                label="iimjobs"
                                defaultChecked={props.data.toHide ? props.data.toHide.iimjobs : false}
                                onChange={(event, data) => {
                                    props.setData({
                                        key: 'toHide.iimjobs',
                                        value: data.checked ? true : false,
                                    });
                                }}
                            />
                            <Checkbox
                                disabled={props.fieldsEditAccess ? false : true}
                                label="hirist"
                                defaultChecked={props.data.toHide ? props.data.toHide.hirist : false}
                                onChange={(event, data) => {
                                    props.setData({
                                        key: 'toHide.hirist',
                                        value: data.checked ? true : false,
                                    });
                                }}
                            />
                            <Checkbox
                                disabled={props.fieldsEditAccess ? false : true}
                                label="updazz"
                                defaultChecked={props.data.toHide ? props.data.toHide.updazz : false}
                                onChange={(event, data) => {
                                    props.setData({
                                        key: 'toHide.updazz',
                                        value: data.checked ? true : false,
                                    });
                                }}
                            />
                        </div>
                    </div>
                </div>

                <div className="inputCategory admin-details">
                    <label className="categoryLabel">Admin Details:</label>

                    <div className="inputGroup">
                        <label className="managementLabels">ID:</label>
                        <div className="managementInputFields adminId">
                            <InputBox
                                disabled={props.fieldsEditAccess ? null : true}
                                placeholder="Enter recruiter id"
                                type="text"
                                value={adminId}
                                onChange={event => {
                                    setAdminId(event.target.value);
                                }}
                            />
                            <Button
                                skin='dark'
                                text="Search"
                                disabled={!props.fieldsEditAccess || adminId.length == 0 ? true : null}
                                clickButton={handleSearchAdmin}
                            />
                            {isAdminLoading ? (
                                <Spinner />
                            ) : (
                                showAdminForm ? (
                                    <Button
                                        text="Clear"
                                        clickButton={handleClearAdmin}
                                        skin="light"
                                    />
                                ) : null
                            )}
                        </div>
                    </div>

                    {props.fieldsEditAccess && showAdminForm ? (
                        <>
                            <div className="inputGroup">
                                <label className="managementLabels">Name:</label>
                                <div className="managementInputFields">
                                    <InputBox
                                        type="text"
                                        value={adminDetails.name}
                                        disabled={true}
                                    />
                                </div>
                            </div>

                            <div className="inputGroup">
                                <label className="managementLabels">Email:</label>
                                <div className="managementInputFields">
                                    <InputBox
                                        type="text"
                                        disabled={true}
                                        value={adminDetails.email}
                                    />
                                </div>
                            </div>

                            <div className="inputGroup">
                                <label className="managementLabels">Platform:</label>
                                <div className="managementInputFields">
                                    <InputBox
                                        type="text"
                                        disabled={true}
                                        value={adminDetails.platform}
                                    />
                                </div>
                            </div>
                        </>
                    ) : null}
                </div>
            </div>

        </div>
    );
};

CompanyForm.propTypes = {
    data: PropTypes.object,
    setData: PropTypes.func,
    industry: PropTypes.array,
    adminId: PropTypes.string,
    fieldsEditAccess: PropTypes.bool,
    editMode: PropTypes.bool,
};

export default CompanyForm;
